export const hasValue = (value: string | null): value is string => {
  return Boolean(value && value.trim().length > 0);
};
